import script from "./PopularDishes.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopularDishes.vue?vue&type=script&setup=true&lang=ts"

import "./PopularDishes.vue?vue&type=style&index=0&id=693b4d42&lang=scss"

const __exports__ = script;

export default __exports__